import React, { useState } from "react";
import { Col } from "reactstrap";
import TruncatedText from "./TruncatedText";

// ============================================================
// DetailField
// ============================================================
interface DetailFieldProps {
  label: string;
  value: any;
  columns?: number;
  truncate?: boolean;
  expandable?: boolean;
  maxChars?: number;
}

const DetailField: React.FC<DetailFieldProps> = ({
  label,
  value,
  columns = 4,
  truncate = false,
  expandable = false,
  maxChars = 300,
}) => {
  const [expanded, setExpanded] = useState(false);
  const textValue = value != null ? String(value) : "";
  const isLongText = textValue.length > maxChars;

  return (
    <Col md={columns} className="mb-3">
      <label className="text-muted fs-12 mb-1 text-uppercase fw-600 ls-1 d-block">
        {label}
      </label>
      <div className="fs-15 fw-500 text-dark" style={{ minHeight: "24px" }}>
        {value != null && value !== "" ? (
          expandable ? (
            isLongText ? (
              <div
                className="p-3 bg-light rounded-3 border"
                style={{
                  lineHeight: "1.6",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "pre-wrap",
                }}
              >
                {!expanded ? (
                  <>
                    <span>
                      {textValue.slice(0, maxChars)}
                      <span className="text-muted">...</span>
                    </span>
                    <br />
                    <button
                      type="button"
                      className="btn btn-link p-0 mt-1 fs-13 text-primary fw-500"
                      onClick={() => setExpanded(true)}
                    >
                      Show more <i className="ri-arrow-down-s-line" />
                    </button>
                  </>
                ) : (
                  <>
                    <span>{textValue}</span>
                    <br />
                    <button
                      type="button"
                      className="btn btn-link p-0 mt-1 fs-13 text-primary fw-500"
                      onClick={() => setExpanded(false)}
                    >
                      Show less <i className="ri-arrow-up-s-line" />
                    </button>
                  </>
                )}
              </div>
            ) : (
              <div
                className="p-3 bg-light rounded-3 border"
                style={{
                  lineHeight: "1.6",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "pre-wrap",
                }}
              >
                {textValue}
              </div>
            )
          ) : truncate ? (
            <TruncatedText text={textValue} />
          ) : (
            value
          )
        ) : (
          <span className="text-muted">-</span>
        )}
      </div>
    </Col>
  );
};

export default DetailField;